// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog__item[data-v-ab711aa4]{width:60%;text-align:left;font:normal normal 700 16px/24px Segoe UI;letter-spacing:0;color:#000!important;opacity:1;padding:1px!important}.right__alignment[data-v-ab711aa4] input{text-align:right!important}", ""]);
// Exports
module.exports = exports;
